import { FC, useEffect, useState, useRef, ChangeEvent, FocusEvent } from 'react';
import { InputDate } from 'components/InputDate';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import {
  setDocumentWorker,
  setNationalityWorker,
  setNotErrorStatusField,
  setWasChanges,
} from 'redux/mainInfo/slice';
import { ListSelect } from 'components/ListSelect';
import styles from './MainDocument.module.scss';
import { ListSelectDisp } from 'components/ListSelectDisp';
import { AddressDadataReg } from 'components/AddressDadataReg';
import { InputMask } from 'components/InputMask';
import { searchSuggestingApi } from 'api/getApi';
import { InputText } from 'ui/InputText';
import {
  setInfoProfileCreate,
  setDatePassport,
  setErrorStatusField,
} from 'redux/createProfile/slice';
import classNames from 'classnames';

interface DataSuggestingValueType {
  code: string;
  name: string;
  region_code: string;
  type: string;
}

interface SuggestingValueType {
  value: string;
  unrestricted_value: string;
  data: DataSuggestingValueType;
}

export const DocumentInfo: FC = () => {
  const { series, number, dep_code, doc_place, doc_date, errorStatusField } = useSelector(
    (state: RootState) => state.createProfile,
  );
  const { documentTypes, nationalitiesList, nationalityWorker, documentWorker } =
    useSelector((state: RootState) => state.mainInfo);
  const [nameDocument, setDocument] = useState<string>('Паспорт РФ');
  const [documentsList, setDocumentsList] = useState<string[]>([]);
  const [temporaryState, setTemporaryState] = useState('');
  const [suggestingValue, setSuggestingValue] = useState<SuggestingValueType[]>([]);
  const [selectedItem, setSelectedItem] = useState<number>(0);
  const dispatch = useDispatch();
  const searchSuggesting = async (value: string) => {
    const result = await searchSuggestingApi(value);
    setSuggestingValue(result);
  };

  useEffect(() => {
    if (documentWorker === 21) {
      setDocument('Паспорт');
      dispatch(setDocumentWorker(21));
    } else if (documentWorker === 10) {
      setDocument('Иностранный паспорт');
      dispatch(setDocumentWorker(10));
    } else if (documentWorker === 12) {
      setDocument('ВНЖ');
      dispatch(setDocumentWorker(12));
    } else if (documentWorker === 14) {
      setDocument('Временное удостоверение');
      dispatch(setDocumentWorker(14));
    } else if (documentWorker === 23) {
      setDocument('Иностранное свидетельство о рождении');
      dispatch(setDocumentWorker(23));
    }
  }, []);

  useEffect(() => {
    if (nameDocument === 'Паспорт') {
      dispatch(setDocumentWorker(21));
    } else if (nameDocument === 'Иностранный паспорт') {
      dispatch(setDocumentWorker(10));
    } else if (nameDocument === 'ВНЖ') {
      dispatch(setDocumentWorker(12));
    } else if (nameDocument === 'Временное удостоверение') {
      dispatch(setDocumentWorker(14));
    } else if (nameDocument === 'Иностранное свидетельство о рождении') {
      dispatch(setDocumentWorker(23));
    }
  }, [nameDocument]);

  useEffect(() => {
    const doc = documentTypes.filter((el: { fns_code?: string }) => el.fns_code);
    const docTypes = doc.map((el: { alias: string }) => {
      return el.alias;
    });
    setDocumentsList(docTypes);
  }, [documentTypes]);

  const handleSelectItem = (elem?: SuggestingValueType) => {
    if (!elem) return;
    dispatch(setWasChanges(true));
    dispatch(
      setInfoProfileCreate({
        key: 'doc_place',
        value: elem?.value,
      }),
    ),
      dispatch(
        setInfoProfileCreate({
          key: 'dep_code',
          value: elem?.data?.code.replace('-', ''),
        }),
      );
    setSuggestingValue([]);
    setTemporaryState('');
    if (errorStatusField.dep_code || errorStatusField.doc_place) {
      dispatch(setNotErrorStatusField('dep_code'));
      dispatch(setNotErrorStatusField('doc_place'));
    }
    inputMaskRef.current?.blur();
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'ArrowUp') {
      setSelectedItem((prev: number) =>
        prev === 0 ? suggestingValue.length - 1 : prev - 1,
      );
    } else if (e.key === 'ArrowDown') {
      setSelectedItem((prev: number) =>
        prev === suggestingValue.length - 1 ? 0 : prev + 1,
      );
    } else if (e.key === 'Enter') {
      handleSelectItem(suggestingValue[selectedItem]);
      setSelectedItem(0);
    }
  };

  useEffect(() => {
    if (suggestingValue?.length > 0) document?.addEventListener('keydown', handleKeyDown);
    return () => {
      document?.removeEventListener('keydown', handleKeyDown);
    };
  }, [suggestingValue, selectedItem]);

  const inputMaskRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className={styles.root} id='mainDocAnchor'>
      <div className={styles.row}>
        <ListSelectDisp
          placeholder='Гражданство'
          list={nationalitiesList}
          defaultValue='Россия'
          search
          activeItem={nationalityWorker}
          setActiveItem={setNationalityWorker}
        />
        <ListSelect
          placeholder='Документ'
          list={documentsList}
          defaultValue='Паспорт РФ'
          search
          activeItem={nameDocument}
          setActiveItem={setDocument}
        />
      </div>

      <div className={styles.row} style={{ position: 'relative' }}>
        <div className={styles.row_item}>
          <div className={styles.series}>
            <InputText
              maxLength={4}
              error={Boolean(errorStatusField.series)}
              nameError='series'
              placeholder='Серия'
              type='text'
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                dispatch(setErrorStatusField({ key: 'series', value: 0 }));
                dispatch(setInfoProfileCreate({ key: 'series', value: e.target.value }));
              }}
              value={series}
              classNameFocus={false}
            />
          </div>

          <div className={styles.number}>
            <InputText
              maxLength={6}
              error={Boolean(errorStatusField.number)}
              nameError='number'
              placeholder='Номер'
              type='text'
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                dispatch(setErrorStatusField({ key: 'number', value: 0 }));
                dispatch(setInfoProfileCreate({ key: 'number', value: e.target.value }));
              }}
              value={number}
              classNameFocus={false}
            />
          </div>
        </div>

        <div className={styles.code}>
          <InputMask
            onBlur={(e: FocusEvent<HTMLInputElement>) => {
              if (!e.target.value)
                dispatch(setErrorStatusField({ key: 'dep_code', value: 1 }));
            }}
            disabled={false}
            inputMaskRef={inputMaskRef}
            error={Boolean(errorStatusField.dep_code)}
            value={dep_code}
            setValue={(value: string) => {
              if (value.length === 0) {
                setSuggestingValue([]);
                dispatch(setInfoProfileCreate({ key: 'dep_code', value }));
                dispatch(setErrorStatusField({ key: 'dep_code', value: 1 }));
              }
              if (value.length > 0 && temporaryState) {
                dispatch(setInfoProfileCreate({ key: 'dep_code', value }));
                searchSuggesting(value);
                dispatch(setErrorStatusField({ key: 'dep_code', value: 0 }));
              }
            }}
            onKeyDown={() => {
              setTemporaryState('1');
              dispatch(setWasChanges(true));
            }}
            placeholder='Код подразделения'
            type='number'
          />
          {!!suggestingValue.length && (
            <ul className={styles.list}>
              {suggestingValue?.map((elem: SuggestingValueType, index: number) => (
                <li
                  className={`${styles.item} ${
                    selectedItem === index ? styles.item_active : ''
                  }`}
                  onClick={() => {
                    handleSelectItem(elem);
                  }}
                  key={index}>
                  {elem?.data?.code} {elem.value}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.issued}>
          <InputText
            error={Boolean(errorStatusField.doc_place)}
            nameError='doc_place'
            placeholder='Выдан'
            type='text'
            value={doc_place}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              dispatch(setErrorStatusField({ key: 'doc_place', value: 0 }));
              dispatch(setInfoProfileCreate({ key: 'doc_place', value: e.target.value }));
            }}
            classNameFocus={false}
          />
        </div>
        <div className={styles.datePassport}>
          <InputDate
            withoutHour
            error={Boolean(errorStatusField.doc_date)}
            nameError='doc_date'
            placeholder='Дата выдачи'
            date={doc_date}
            setDate={setDatePassport}
          />
        </div>
      </div>

      <div
        className={classNames(
          styles.address,
          errorStatusField.reg_address && styles.address_error,
        )}>
        <AddressDadataReg placeholder='Адрес регистрации' objKey='reg_address' />
      </div>

      <div
        className={classNames(
          styles.address,
          errorStatusField.birth_place && styles.address_error,
        )}>
        <AddressDadataReg placeholder='Место рождения' objKey='birth_place' />
      </div>
    </div>
  );
};
